export const daneTechniczne = {
    pl: [
      {
        title: 'Dom wolonostojący',
        submenu: [
          {
            Powierzchnia_terenu: '500-580m2',
            Powierzchnia_zabudowy: '99m2',
            Powierzchnia_uzytkowa: '145m2',
            Kubatura: '757m3',
            Zabudowa: 'Dom wolnostojący',
            Ściany_nośne_zewnętrzne_i_wewnętrzne: 'Murowane z betonu komórkowego kl. 15MPa na zaprawie klejowej.',
            Dach: 'Więźba dachowa drewniana dwuspadowa o kontrukcji krokwiowo-jętkowej pokryta blachą w kolorze antracytowym.',
            Instalacja_grzewcza: 'Pompa ciepła z ogrzewaniem podłogowym',
            Instalacja_wentylacyjna: 'System rekuperacji.',
            Ogrodzenie: 'Otwarty front budynku wykonano z pełnego murowanego ogrodzenia, wzdłuż obwodu zastosowano ogrodzenie z paneli siatkowych na podmurówce.',
            Oprogramowanie: 'Możliwość instalacji systemu smarthouse do zdalnego sterowania poszczególnymi urządzeniami...'
          }
        ],
      },
      {
        title: 'Dom wolnostojący typu bliźniak (przewidywany w kolejnych etapach realizacji)',
        submenu: [
          {
            Powierzchnia_terenu: '530-550m2',
            Powierzchnia_zabudowy: '80m2',
            Powierzchnia_uzytkowa: '120m2',
            Kubatura: '680m3',
            Zabudowa: 'Dom wolnostojący',
            Ściany_nośne_zewnętrzne_i_wewnętrzne: 'Murowane z betonu komórkowego kl. 15MPa na zaprawie klejowej.',
            Dach: 'Więźba dachowa drewniana dwuspadowa o kontrukcji krokwiowo-jętkowej pokryta blachą w kolorze antracytowym.',
            Instalacja_grzewcza: 'Pompa ciepła z ogrzewaniem podłogowym',
            Instalacja_wentylacyjna: 'System rekuperacji.',
            Ogrodzenie: 'Otwarty front budynku wykonano z pełnego murowanego ogrodzenia...',
            Oprogramowanie: 'Możliwość instalacji systemu smarthouse do zdalnego sterowania...'
          }
        ],
      },
    ],
  
    en: [
      {
        title: 'Detached House',
        submenu: [
          {
            Plot_area: '500–580m²',
            Building_area: '99m²',
            Usable_area: '145m²',
            Cubature: '757m³',
            Development_type: 'Detached house',
            Load_bearing_walls: 'Made of cellular concrete, class 15MPa, with adhesive mortar.',
            Roof: 'Wooden gable roof with rafter-collar structure, covered with anthracite-colored sheet metal.',
            Heating_installation: 'Heat pump with underfloor heating.',
            Ventilation: 'Mechanical ventilation with heat recovery.',
            Fence: 'Solid brick front fence, mesh panel fencing with foundation on the perimeter.',
            Smart_home: 'Smart home system installation possible for remote control of garage gate, heat pump, lighting, alarm, etc.'
          }
        ],
      },
      {
        title: 'Semi-detached house (planned in next stages)',
        submenu: [
          {
            Plot_area: '530–550m²',
            Building_area: '80m²',
            Usable_area: '120m²',
            Cubature: '680m³',
            Development_type: 'Detached house',
            Load_bearing_walls: 'Made of cellular concrete, class 15MPa, with adhesive mortar.',
            Roof: 'Wooden gable roof with rafter-collar structure, covered with anthracite-colored sheet metal.',
            Heating_installation: 'Heat pump with underfloor heating.',
            Ventilation: 'Mechanical ventilation with heat recovery.',
            Fence: 'Solid brick front fence, mesh panel fencing with foundation on the perimeter.',
            Smart_home: 'Smart home system installation possible for remote control of garage gate, heat pump, lighting, alarm, etc.'
          }
        ],
      },
    ],
  };
  